import styled from "styled-components";

const ButtonGroup = styled.div`
  display: flex;
  position: ${(props) => (!props.absoluteRight ? "inherit" : "absolute")};
  right: ${(props) => (!props.absoluteRight ? "auto" : "0")};
`;

export default ButtonGroup;
